<template lang="pug">
  div(class='app-workspace-inner')
    div(class='genplan')
      div(ref='genplanContainer' class='genplan-container')
    div(class='listing')
      div(v-if='hasNight' class='night-toggle')
        v-checkbox(v-model='night' label='Ночной ГП' hide-details color='primary')
      div(class='scroll')
        v-card(v-for='obj in objects' :key='obj.id' class='mb-3')
          v-card-title {{obj.name}}
          v-card-actions
            v-btn(v-if='!obj.point' @click='createMark(obj)' flat outline) метка
            v-btn(v-if='!obj.polygon' @click='createPath(obj)' flat outline) обводка
</template>

<script>
import * as L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-rastercoords'
import 'leaflet-editable'

// Советы бывалых для отрисовки дефолтного маркера
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})
// eof

export default {
  // Нужно для создания новой обводки
  // маркера и привязки к существующей СУЩНОСТИ
  data: () => ({ obj: null, night: false }),

  // Структура / модель, полученная от родителя
  // содержит обводки / маркеры, которые будем редактировать
  // в противном случае – создаем новые и заполняем
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  mounted() {
    // Так нужно, тормозит анимация открытия
    // модального окна – те, открываем окно, потом
    // рисуем карту
    this.openTimeout = setTimeout(() => {
      this.createGenplan()
      this.createObjects()
    }, 250)
  },

  destoyed() {
    // Удаляем таймер, если закрыли модальное окно
    // что мало вероятно, это от утечки памяти
    clearTimeout(this.openTimeout)
  },

  methods: {
    reinit() {
      if (this.map) {
        this.map.remove()
      }

      this.createGenplan()
      this.createObjects()
    },

    createGenplan() {
      let { width, height, minZoom } = this.options
      let dimensions = [width, height]

      // Создаем экземпляр карты
      this.map = L.map(this.$refs.genplanContainer, { editable: true })

      // Читаем доки – много писать про проекции
      let rc = new L.RasterCoords(this.map, dimensions)

      this.map.setMaxZoom(rc.zoomLevel())
      this.map.setMinZoom(minZoom)
      this.map.setView(
        rc.unproject([dimensions[0] / 2, dimensions[1] / 2]),
        minZoom
      )

      // Грузим тайлы генплана с удаленной машины
      // ночные, если переключатель включен
      this.tileLayer = L.tileLayer(this.currentTileUrl, {
        noWrap: true
      }).addTo(this.map)

      // События рисовалки – все из доков
      this.map.editTools.on('editable:drawing:commit', this.setDrawingResults)
      this.map.editTools.on('editable:dragend', this.setDrawingResults)
      this.map.editTools.on('editable:editing', this.setDrawingResults)
    },

    createObjects() {
      // Возможно, может прийти инвалидный GeoJSON
      // поэтому будем ловить исключения
      let createObject = obj => {
        try {
          let features = [obj.point, obj.polygon]
          features.forEach(json => {
            let featureGroup = L.geoJSON(json).addTo(this.map)
            featureGroup.eachLayer(layer => {
              // Проверяем наличие свойства объекта
              // или создаем свойство data
              // в уже существующее свойство options
              layer.options || (layer.options = {})
              layer.options.data = obj
              // Включаем возмозность редактирования
              layer.enableEdit()
            })
          })
        } catch (e) {
          this.$log.info('Ошибка создания полигона или маркера', obj)
        }
      }

      // Понеслась создавалка гео объектов
      this.objects.forEach(createObject)

      // TODO: иначе не включается
      // двигалка маркера
      this.map.editTools.startMarker()
      this.map.editTools.stopDrawing()
    },

    // Делаем локальную копию из коллекции объектов
    // и рисуем полигон
    createPath(obj) {
      this.obj = { ...obj }
      this.map.editTools.startPolygon()
    },

    // СМ выше
    createMark(obj) {
      this.obj = { ...obj }
      this.map.editTools.startMarker()
    },

    // Засетим результаты рисования, и тп
    setDrawingResults({ layer }) {
      // Результирующая геометрия
      let results = layer.toGeoJSON()
      // Создание / редактирование существующего объекта
      let datasource = this.obj ? this.obj : layer.options.data

      // Пишем промежуточный результат
      // маркер / обводка в ранее выбранный датасорс
      switch (results.geometry.type) {
        case 'Point':
          datasource.point = results
          break
        case 'Polygon':
          datasource.polygon = results
          break
      }

      // Оповестим слушателей об изменении набора объектов
      // маркеров, полигинонов
      this.$emit(
        'input',
        // Мутируем исходную модель, и подменяем новый набор
        // objects на свой, со своей геометрией
        // результирующая модель будет содержать объекты с новыми координатами
        // маркеров и обводок
        Object.assign(this.value, {
          objects: this.objects.map(obj => {
            return obj.id === datasource.id ? datasource : obj
          })
        })
      )

      // Запишем данные в объект лифлетанафилета
      // для дальнейшего использования
      if (this.obj) {
        layer.options || (layer.options = {})
        // Запишем именно копию,
        // дабы не менять исходный объект
        layer.options.data = { ...this.obj }
        // Удаляем локальную копию
        this.obj = null
      }
    }
  },

  // Сахар, для быстрого доступа
  // к свойствам, можно было и так this.value.options
  // this.value – модель, полученная от parent
  computed: {
    options() {
      return this.value.options
    },

    objects() {
      return this.value.objects
    },

    // Чекбокс «Ночной ГП» показываем
    // только при заполненных дневном и ночном урлах
    hasNight() {
      return !!(this.options.url && this.options.url_night)
    },

    currentTileUrl() {
      return this.night && this.options.url_night
        ? this.options.url_night
        : this.options.url
    }
  },

  watch: {
    night() {
      // Меняем урл слоя тайлов на дневной / ночной
      if (this.tileLayer) {
        this.tileLayer.setUrl(this.currentTileUrl)
      }
    },

    'value.opened'(opened) {
      // Необходимо для правильной отрисовки
      // карты при повторном открытии модального окна
      // а все из-за анимаций – карта не успевает правильно
      // рассчитать viewport
      // проверим наличие карты, меняем только при
      // открытом модальном окне
      if (this.map && opened) {
        this.map.invalidateSize()
      }
    }
  }
}
</script>

<style scoped>
.genplan-container {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
}
.app-workspace-inner {
  top: 64px;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  display: flex;
}
.genplan {
  flex: 1;
  position: relative;
}
.listing {
  flex: 0 1 auto;
  width: 350px;
  background: #f5f5f5;
  border-right: solid 1px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
}
.night-toggle {
  flex: 0 0 auto;
  padding: 16px 24px 0;
  background: #f5f5f5;
}
.scroll {
  flex: 1;
  min-height: 0;
  width: 100%;
  padding: 24px;
  position: relative;
  overflow-y: scroll;
}
</style>
